import React, { useEffect, useState, useContext } from "react";
import { subcatHierarcyContext } from "../context/SubcatHierarcyContext";
import { categoryHierarcyContext } from "../context/CategoryHierarcyContext";
import { subcatRestrictContext } from "../context/SubcatRestrictContext";

import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import useLoginfo from "../../utils/useLoginfo";
import { useHistory } from "react-router-dom";

const RestrictSubcategory = () => {
  const { fetchSUBCategoryHierarcyAction, subcategoryHierarcy } = useContext(
    subcatHierarcyContext
  );

  const { fetchCategoryHierarcyAction, categoryHierarcy } = useContext(
    categoryHierarcyContext
  );

  const { fetchSUBCategoryRestrictAction, subcategoryRestrict, addUpdateSUBCategoryRestrictAction, deleteSUBCategoryRestrictAction, getSingleSUBCategoryRestrictAction } = useContext(
    subcatRestrictContext
  );

  const history = useHistory()
  //OKTA
  const { tokenVal } = useLoginfo()

  const [formData, setFormData] = useState({
    ASSORTMENT_SUB: "",
    CAT_ID: "",
  });

  useEffect(() => {
    if (formData.CAT_ID) {
      console.log(formData.CAT_ID)
      fetchSUBCategoryRestrictAction(formData.CAT_ID, tokenVal)
    }
    fetchCategoryHierarcyAction(tokenVal);
    fetchSUBCategoryHierarcyAction(tokenVal);

  }, [formData.CAT_ID, tokenVal]);

  //handle form change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const [inpValue, setinpValue] = useState([])

  const [flag, setflag] = useState(false);
  //handle form submit
  const handleSubmit = (e) => {
    e.preventDefault();
    //add Assortment_ID
    if (flag) {
      console.log(inpValue.toString(), { ...formData });  
      if(subcategoryRestrict.length >0){   
      addUpdateSUBCategoryRestrictAction({
        "ID": 0,
        "CAT_ID": formData.CAT_ID,
        "ASSORTMENT_SUB": formData.ASSORTMENT_SUB,
        "RESTRICTED_CAT_ID": subcategoryRestrict.map(i => i.RESTRICTED_CAT_ID).toString(),
        "ACTIVE": "Y",
        "DRAFT": "N",
        "DELETE": "N",
        "CREATE_BY": "1",
        "UPDATE_BY": "1"
      }, tokenVal, history)
    } else {
      alert("Please add the Sub-Categories")
    }
    }
  };

  //handle form cancel
  const handleCancel = (e) => {
    window.location.href = "/subcategory-restrict";
  };

  const handleinpChange = (e) => {

    inpValue?.includes(e.target.value) ? setinpValue(inpValue.filter(item => item != e.target.value)) : setinpValue([...inpValue, e.target.value])
  }

  const [removeVal, setremoveVal] = useState([])

  const handleremoveChange = (e) => {

    removeVal?.includes(e.target.value) ? setremoveVal(removeVal.filter(item => item != e.target.value)) : setremoveVal([...removeVal, e.target.value])
  }

  const addBtn = (e) => {
    e.preventDefault();
    if(inpValue.length>0){
    console.log(inpValue.toString())
    getSingleSUBCategoryRestrictAction({
      "ID": 0,
      "CAT_ID": formData.CAT_ID,
      "ASSORTMENT_SUB": formData.ASSORTMENT_SUB,
      "RESTRICTED_CAT_ID": inpValue.toString(),
      "ACTIVE": "N",
      "DRAFT": "Y",
      "DELETE": "N",
      "CREATE_BY": "1",
      "UPDATE_BY": "1"
    }, tokenVal, history)
  } else {
    alert("Please select the Sub-Categories");
  }
  }

  const removeBtn = (e) => {
    e.preventDefault();
    console.log(formData.ASSORTMENT_SUB);
    if(removeVal.length>0 && subcategoryRestrict.length >0){
    deleteSUBCategoryRestrictAction(removeVal.toString(), formData.CAT_ID, tokenVal)
    }
    else {
      alert("Please select the Restricted Sub-Categories");
    }
  }

  return (
    <div>
      <h2 style={{ textAlign: "center" }}>Subcategory Restriction</h2>

      <form className="flex-container" onSubmit={handleSubmit}>
        <div style={{ marginLeft: "15px" }}>
          <div className="flex-container">
            <label className="first-box" style={{ marginRight: "10px" }}>
              Category ID-Category Description
            </label>

            <TextField
              size="small"
              required={flag}
              name="ASSORTMENT_SUB"
              value={formData.ASSORTMENT_SUB}
              onChange={handleChange}
              className="depart"
              id="outlined-select-currency"
              select
            >
              {categoryHierarcy.map((option) => (
                <MenuItem
                  key={option.ASSORTMENT_SUB}
                  value={option.ASSORTMENT_SUB}
                >
                  {option.ASSORTMENT_SUB}-{option.ASSORTMENT_SUB_DESC}
                </MenuItem>
              ))}
            </TextField>
          </div>

          <div className="flex-container">
            <label className="first-box" style={{ marginRight: "10px" }}>
              Sub Category Id-Sub Category Description
            </label>

            <TextField
              size="small"
              required={flag}
              name="CAT_ID"
              value={formData.CAT_ID}
              onChange={handleChange}
              className="depart"
              id="outlined-select-currency"
              select
            >
              {subcategoryHierarcy
                .filter((i) => i.ASSORTMENT_SUB == formData.ASSORTMENT_SUB)
                .map((option) => (
                  <MenuItem key={option.CAT_ID} value={option.CAT_ID}>
                    {option.CAT_ID}-{option.CAT_DS}
                  </MenuItem>
                ))}
            </TextField>
          </div>

          <div
            style={{
              marginTop: "330px",
              display: "flex",
            }}
          >
            <div className="save-btn">
              <Button
                type="submit"
                variant="contained"
                color="success"
                onClick={(e) => setflag(true)}
                size="large"
              >
                <span className="cat-radio">Save</span>
              </Button>
            </div>
            <div>
              <Button
                className=""
                variant="contained"
                color="error"
                onClick={handleCancel}
                size="large"
              >
                Cancel
              </Button>
            </div>
          </div>
        </div>

        <div style={{ marginRight: "15px", marginTop: "15px" }}>
          <label className="">Sub-Categories</label>
          <div className="planogram assignplan">
            {subcategoryHierarcy.map((item) => {
              return (<label key={item.CAT_ID} style={{ marginBottom: "11px", fontSize: "0.95rem", marginRight: "0px" }}>
                <input style={{ width: "15px", marginRight: "5px" }}
                  type="checkbox"
                  value={item.CAT_ID}
                  onChange={handleinpChange}
                />
                {item.CAT_ID}, {item.CAT_DS}
              </label>)
            })}
          </div>

          <div className="labelselected">
            <Button
              type="submit"
              variant="contained"
              onClick={addBtn}
              size="large"
            >
              <span className="cat-radio">Add</span>
            </Button>
          </div>

          <label style={{ marginLeft: "-90px", marginTop: "40px" }}>
            Restricted Sub-Categories
          </label>
          <div className="planogram assignplan">

            {subcategoryRestrict.map((item) => {
              return (<label key={item.RESTRICTED_CAT_ID} style={{ marginBottom: "11px", fontSize: "0.95rem", marginRight: "0px" }}>
                <input style={{ width: "15px", marginRight: "5px" }}
                  type="checkbox"
                  value={item.RESTRICTED_CAT_ID}
                  onChange={handleremoveChange}
                />
                {item.RESTRICTED_CAT_ID}, {item.CAT_DS}
              </label>)
            })}
          </div>

          <div className="labelselected">
            <Button
              type="submit"
              color="secondary"
              variant="contained"
              onClick={removeBtn}
              size="large"
            >
              <span className="cat-radio">Remove</span>
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default RestrictSubcategory;
